import { ActiveStateVariant } from '@graftcode/design-system'

import { GATEWAY_STATUS } from '@common/core.const'

export function mapGatewayStatusToVariant(status?: string) {
  switch (status) {
    case GATEWAY_STATUS.ONLINE:
      return ActiveStateVariant.Online
    case GATEWAY_STATUS.WARNING:
      return ActiveStateVariant.Away
    case GATEWAY_STATUS.ERROR:
      return ActiveStateVariant.Busy
    case GATEWAY_STATUS.OFFLINE:
    default:
      return ActiveStateVariant.Offline
  }
}
